import React from 'react'
import CommonText from '../common/CommonText.jsx'
import CommonIconButton from '../common/CommonIconButton.jsx'

// iconText에 props로 객체가 원소인 배열을 전달해서 사용합니다.
// 객체의 icon key 에는 iconButtonType이 들어옵니다.
// 객체의 text key 에는 좋아요 수나 댓글의 수가 text로 들어옵니다.
const IconText = ({
  iconText = [
    { id: 1, icon: 'thumb', text: '93', color: '#ffffff' },
    { id: 2, icon: 'comment', text: '10', color: '#ffffff' },
  ],
}) => {
  const iconStyle = {
    marginRight: '10px',
  }

  const wrapperStyle = {
    display: 'inline-block',
  }

  const tag = iconText.map((_iconText, index) => {
    return (
      <div style={wrapperStyle} key={_iconText.id}>
        <CommonIconButton
          onClick={_iconText.onClick}
          width={15}
          height={15}
          iconButtonType={_iconText.icon}
          style={{ ...iconStyle }}
        />
        <CommonText
          color={_iconText.color}
          style={{ marginRight: index !== 1 ? '20px' : '' }}>
          {_iconText.text}
        </CommonText>
      </div>
    )
  })

  return tag
}

export default IconText
